import React, { useState } from "react";
import { Button, Form, Modal, Table } from "react-bootstrap";
import { MdBlock } from "react-icons/md";
import { blockUserById } from "../../services/axios/apiManager";
import { toast } from "sonner";
import { add, format } from "date-fns";
import LoadingSpinner from "../../Components/spinner";
import { handleErrors } from "../../services/dataManager";
import { Formik } from "formik";
import * as Yup from "yup";

const BlockUserModal = ({
  openBlockModal,
  setOpenBlockModal,
  userID,
  setUserID,
  fetchUserList,
  pagination,
  navigate,
}) => {
  const [loading, setLoading] = useState(false);
  const handleCloseModal = () => {
    setUserID(null);
    setOpenBlockModal(false);
  };

  const blockValidations = Yup.object().shape({
    reason: Yup.string().trim().required("Reason is required"),
  });
  const handleSubmitForm = async (blockData) => {
    setLoading(true);
    const { reason, blockedFor } = blockData;
    const addedDate = add(new Date(), { days: parseInt(blockedFor) });
    const temp = format(addedDate, "yyyy-MM-dd");
    const data = {
      user_id: userID,
      reason: reason,
      blocked_for_days: blockedFor,
      blocked_till: temp,
    };
    const res = await blockUserById(data);

    if (res?.data?.success) {
      handleCloseModal();
      await fetchUserList(pagination);
      toast.success("User has been blocked.", { duration: 2000 });
    } else {
      handleErrors(res, navigate);
    }
    setLoading(false);
  };
  return (
    <Modal show={openBlockModal} onHide={handleCloseModal} size="lg" centered>
      <Modal.Header closeButton className="bg-dark text-light border-0">
        <Modal.Title>Block User</Modal.Title>
      </Modal.Header>
      <Modal.Body className="bg-dark text-light">
        <Formik
          initialValues={{
            reason: "",
            blockedFor: 1,
          }}
          validationSchema={blockValidations}
          onSubmit={async (values) => {
            try {
              setLoading(true);
              await handleSubmitForm(values);
            } catch (error) {
              console.log("Error upon Add Update Role", error);
            } finally {
              setLoading(false);
            }
          }}
        >
          {({ handleChange, handleSubmit, values, errors, touched }) => (
            <div>
              <div className="mb-3">
                <label htmlFor="blockDuration" className="form-label">
                  Reason:
                </label>
                <Form.Control
                  type="text"
                  data-testid="reason"
                  id="reason"
                  className="bg-dark text-light border-light"
                  value={values.reason}
                  onChange={handleChange("reason")}
                />
                {errors?.reason && touched?.reason ? (
                  <span className="text-danger">{errors?.reason}</span>
                ) : null}
              </div>
              <div className="mb-3">
                <label htmlFor="blockDuration" className="form-label">
                  Block Duration:
                </label>
                <Form.Select
                  id="blockDuration"
                  data-testid="duration"
                  required
                  className="form-select bg-dark text-light border-light"
                  value={values.blockedFor}
                  onChange={handleChange("blockedFor")}
                >
                  <option value="1">One Day</option>
                  <option value="7">7 days</option>
                  <option value="30">30 days</option>
                  <option value="365">365 days</option>
                  <option value="3650">10 Years</option>
                </Form.Select>
              </div>
              <div className="container-fluid">
                <div
                  className="d-flex justify-content-end align-item-center"
                  data-testid="loading-spinner"
                >
                  <Button
                    variant="secondary"
                    onClick={handleCloseModal}
                    data-testid="closeBtn"
                    className="px-4 py-2 mx-2"
                  >
                    Close
                  </Button>
                  {loading ? (
                    <LoadingSpinner size="lg" />
                  ) : (
                    <Button
                      variant="danger"
                      data-testid="block"
                      onClick={() => handleSubmit()}
                      className="d-flex align-items-center px-4 py-2"
                    >
                      <MdBlock className="me-2" /> Block
                    </Button>
                  )}
                </div>
              </div>
            </div>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
};

export default BlockUserModal;
